const readMoreElems = document.querySelectorAll('.js-mobile-read-more-item');

if (readMoreElems) {
	readMoreElems.forEach(elem => {
		const trigger = elem.querySelector('.js-mobile-read-more-trigger');
		const content = elem.querySelector('.js-mobile-read-more-content');

		if (trigger) {
			trigger.addEventListener('click', () => {
				content.classList.toggle('hidden');
				elem.classList.toggle('is-open');
			});
		}
	});
}
